<fullscreen-page>
    <content-column look="dark" [helpSwitch]="true">
        <div slot="content" class="p-3 flex-fill w-100 mx-auto overflow-auto">
            <dx-data-grid id="gridContainer"
                          #dataGrid
                          class="h-100"
                          [dataSource]="model"
                          [remoteOperations]="false"
                          [allowColumnReordering]="true"
                          [rowAlternationEnabled]="true"
                          [allowColumnResizing]="true"
                          [noDataText]="noDataText"
                          [showBorders]="true"
                          [hoverStateEnabled]="true"
                          (onEditingStart)="onEditClicked($event)"
                          (onRowPrepared)="onRowPrepared($event)"
                          [columnMinWidth]="50">
                <dxo-data-grid-column-chooser height="340px"
                                              #columnChooser
                                              [enabled]="true"
                                              mode="select">
                    <dxo-data-grid-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button" />
                    <dxo-data-grid-search [enabled]="true" />
                    <dxo-data-grid-selection [selectByClick]="true" [recursive]="true" />
                </dxo-data-grid-column-chooser>

                <dxo-data-grid-toolbar>
                    <dxi-data-grid-item location="before">
                        <dx-button stylingMode="text"
                                   (onClick)="onCollapseAll()"
                                   type="default"
                                   icon="chevronright"
                                   hint="{{ 'Alle Gruppen schliessen' | translate }}"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item location="before">
                        <dx-button stylingMode="text"
                                   (onClick)="onExpandAll()"
                                   type="default"
                                   icon="chevrondown"
                                   hint="{{ 'Alle Gruppen öffnen' | translate }}"></dx-button>
                    </dxi-data-grid-item>

                    <dxi-data-grid-item location="before">
                        <dx-button [visible]="canView('refreshButton')"
                                   stylingMode="outlined"
                                   type="default"
                                   text="{{ 'Aktualisieren' | translate }}"
                                   (onClick)="refresh()"
                                   hint="{{ 'Katalogliste aktualisieren' | translate }}"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item location="before">
                        <dx-button [visible]="canView('importButton')"
                                   stylingMode="outlined"
                                   type="default"
                                   text="{{ 'Importieren' | translate }}"
                                   (onClick)="showImportCatalog()"
                                   hint="{{ 'Katalog hochladen (Excel, BMEcat)' | translate }}"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item location="before">
                        <dx-button [visible]="canView('newCatalogButton')"
                                   stylingMode="outlined"
                                   type="default"
                                   text="{{ 'Neuer Katalog' | translate }}"
                                   (onClick)="showAddCatalog()"
                                   hint="{{ 'Neuen, leeren Katalog anlegen' | translate }}"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item [visible]="catalogService.copyCatalogId != ''" location="before">
                        <dx-button stylingMode="outlined"
                                   type="default"
                                   text="Katalog einfügen"
                                   (onClick)="pasteCatalog()"
                                   hint="{{ 'Katalog einfügen' | translate }}"></dx-button>
                    </dxi-data-grid-item>

                    <dxi-data-grid-item location="after">
                        <dx-button stylingMode="outlined"
                                   type="default"
                                   text="{{ 'JobFiles' | translate }}"
                                   (click)="showJobData()"
                                   *ngIf="loginService.isAdmin"
                                   title="JobData"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item location="after">
                        <dx-button [visible]="canView('backupButton')"
                                   stylingMode="outlined"
                                   type="default"
                                   text="{{ 'Backups' | translate }}"
                                   (click)="showBackUp()"
                                   title="BackUps"
                                   hint="{{ 'Vorhandene Backups anzeigen' | translate }}"></dx-button>
                    </dxi-data-grid-item>
                    <dxi-data-grid-item name="columnChooserButton" />
                    <dxi-data-grid-item name="searchPanel" />
                    <dxi-data-grid-item name="groupPanel" />
                </dxo-data-grid-toolbar>
                <dxo-state-storing [enabled]="true"
                                   type="localStorage"
                                   storageKey="CatalogListStateNewUIV2"
                                   [savingTimeout]="0"></dxo-state-storing>

                <dxo-editing mode="row"
                             [allowDeleting]="canView('catalogDelete')"
                             [allowUpdating]="canView('catalogUpdate')"
                             [useIcons]="true">
                    <dxo-texts confirmDeleteMessage="{{ 'Wollen Sie den Katalog wirklich löschen' | translate }}?"
                               confirmDeleteTitle="{{ 'Katalog löschen' | translate }}"></dxo-texts>
                </dxo-editing>
                <dxo-grouping [autoExpandAll]="true"></dxo-grouping>
                <dxo-summary>
                    <dxi-group-item column="catalogName"
                                    summaryType="count"
                                    [customizeText]="customizeCatalogCount"></dxi-group-item>
                </dxo-summary>
                <dxo-data-grid-header-filter [visible]="true"></dxo-data-grid-header-filter>
                <dxo-group-panel [visible]="true"></dxo-group-panel>
                <dxo-paging [enabled]="false"></dxo-paging>
                <dxo-scrolling mode="virtual" showScrollbar="always"></dxo-scrolling>
                <dxo-search-panel [visible]="true"
                                  [highlightCaseSensitive]="true"
                                  placeholder="{{ 'Kataloge suchen' | translate }}"></dxo-search-panel>

                <dxi-column dataField="catalogName"
                            caption="{{ 'Katalog' | translate }}"
                            cellTemplate="catalogNameTemplate"
                            [allowHiding]="false"></dxi-column>
                <div *dxTemplate="let catalog of 'catalogNameTemplate'">
                    <dx-button stylingMode="text"
                               (onClick)="catalogSelected(catalog.data)"
                               text="{{ catalog.data.catalogName }}"
                               type="default"
                               style="min-width: 32px"></dx-button>
                </div>

                <dxi-column dataField="supplier.supplierName" caption="{{ 'Lieferant' | translate }}"></dxi-column>

                <dxi-column dataField="responsible"
                            caption="{{ 'Verantwortlicher' | translate }}"
                            style="padding-top: 0px"
                            [allowEditing]="false"
                            cellTemplate="responsibleTemplate"></dxi-column>
                <div *dxTemplate="let catalog of 'responsibleTemplate'">
                    <dx-autocomplete class="dataGridAutocomplete"
                                     [minSearchLength]="0"
                                     [dataSource]="catalogService.responsibleList"
                                     [showClearButton]="true"
                                     [showDropDownButton]="true"
                                     valueChangeEvent="blur"
                                     (onValueChanged)="updateResponsible(catalog)"
                                     [(value)]="catalog.data.responsible"
                                     [readOnly]="!canEdit('verantwortlicher', catalog.data)"></dx-autocomplete>
                </div>

                <dxi-column dataField="note" caption="{{ 'Notiz' | translate }}" cellTemplate="noteTemplate"></dxi-column>
                <div *dxTemplate="let catalog of 'noteTemplate'">
                    <div (mouseenter)="showMemo(catalog)" (mouseleave)="hideMemo()" id="memo{{ catalog.rowIndex }}">
                        <dx-text-box [readOnly]="!canEdit('catalogNote', catalog.data)"
                                     [(value)]="catalog.data.note"
                                     [showClearButton]="false"
                                     (onValueChanged)="update(catalog)"></dx-text-box>
                    </div>
                </div>

                <dxi-column dataField="catalogVersion" caption="{{ 'Version' | translate }}" [width]="80"></dxi-column>

                <dxi-column name="catalogState"
                            [visible]="false"
                            [allowEditing]="false"
                            [calculateCellValue]="displayCatalogState"
                            [allowFiltering]="true"
                            [allowHeaderFiltering]="true"
                            [calculateFilterExpression]="catalogStateFilterExpression"
                            [headerFilter]="{ dataSource: catalogStateHeaderFilterDataSource }"
                            caption="{{ 'Katalogstatus' | translate }}"></dxi-column>

                <dxi-column dataField="thumbUri"
                            caption=""
                            [width]="35"
                            [allowFiltering]="false"
                            [allowSorting]="false"
                            cellTemplate="imageCellTemplate2"
                            caption="{{ 'Bild' | translate }}"></dxi-column>
                <div *dxTemplate="let data of 'imageCellTemplate2'" style="overflow: visible; height: 25px">
                    <div (mouseenter)="showImage(data.value, data.rowIndex)"
                         (mouseleave)="hideImage()"
                         style="position: relative; top: -10px; left: -7px">
                        <span *ngIf="!data.value" class="glyphicon glyphicon-picture" style="font-size: 35px"></span>
                        <img *ngIf="data.value"
                             src="{{ data.value }}{{ mimedate() }}"
                             style="height: 35px"
                             id="link{{ data.rowIndex }}" />
                    </div>
                </div>

                <dxi-column dataField="language"
                            caption="{{ 'Sprache' | translate }}"
                            width="55"
                            cellTemplate="catalogLanguageTemplate"
                            *ngIf="loginService.hasAddonTranslate"></dxi-column>
                <div *dxTemplate="let data of 'catalogLanguageTemplate'">
                    <img src="images/flags/{{ getLanguageFlag(data.data.language) }}" class="flag" />
                </div>

                <dxi-column dataField="date"
                            caption="{{ 'Datum' | translate }}"
                            dataType="date"
                            [format]="{ type: 'dd.MM.yyyy' }"
                            [width]="105"></dxi-column>
                <dxi-column dataField="categoryCount" caption="{{ 'Kategorien' | translate }}" [width]="100"></dxi-column>
                <dxi-column dataField="productCount" caption="{{ 'Produkte' | translate }}" [width]="100"></dxi-column>
                <dxi-column dataField="pimGroup" caption="{{ 'Gruppe' | translate }}" [groupIndex]="0"></dxi-column>
                <dxi-column dataField="lastUpdate"
                            caption="{{ 'Änderung' | translate }}"
                            dataType="date"
                            [format]="{ type: 'dd.MM.yyyy' }"
                            [width]="105"></dxi-column>
                <dxi-column dataField="isPublic"
                            caption="{{ 'Öffentlich' | translate }}"
                            [width]="100"
                            cellTemplate="isPublicTemplate"></dxi-column>
                <div *dxTemplate="let catalog of 'isPublicTemplate'">
                    <div *ngIf="!catalog.data.isVirtual">
                        <dx-switch [readOnly]="!canEdit('isPublic', catalog.data)"
                                   (onValueChanged)="update(catalog)"
                                   [(value)]="catalog.data.isPublic"
                                   switchedOffText="{{ 'Nein' | translate }}"
                                   switchedOnText="{{ 'Ja' | translate }}"></dx-switch>
                    </div>
                </div>


                <dxi-column *ngIf="loginService.hasAddonDataProcess"
                            [calculateCellValue]="displayContainerTypesUsedByCatalog"
                            [allowFiltering]="true"
                            [allowHeaderFiltering]="true"
                            [calculateFilterExpression]="containerTypeFilterExpression"
                            [headerFilter]="{ dataSource: containerTypeHeaderFilterDataSource }"
                            caption="{{ 'Stage' | translate }}"></dxi-column>

                <dxi-column *ngIf="loginService.hasAddonDataProcess"
                            [calculateCellValue]="displayContainersUsedByCatalog"
                            [allowFiltering]="true"
                            [allowHeaderFiltering]="true"
                            [calculateFilterExpression]="containerNameFilterExpression"
                            [headerFilter]="{ dataSource: containerNameHeaderFilterDataSource }"
                            caption="{{ 'Containername' | translate }}"></dxi-column>

                <dxi-column *ngIf="loginService.hasAddonDEVELOPMENT"
                            dataField="isVirtual"
                            caption="{{ 'Virtuell' | translate }}"
                            [allowEditing]="false"></dxi-column>

                <dxi-column type="buttons" [allowHiding]="false"
                            caption="{{ 'Aktionen' | translate }}">
                    <dxi-button text="{{ 'Katalog duplizieren' | translate }}"
                                icon="copy"
                                [onClick]="duplicateCatalog">
                    </dxi-button>
                    <dxi-button text="{{ 'Katalog kopieren' | translate }}"
                                icon="description"
                                [onClick]="copyCatalog">
                    </dxi-button>
        
                    <dxi-button text="{{ 'Wiederherstellungspunkt erstellen' | translate }}"
                                icon="clock"
                                [onClick]="createRestorePoint">
                    </dxi-button>
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete" [onClick]="showCustomDeleteDialog"></dxi-button>
                    <dxi-button *ngIf="loginService.hasAddonDataProcess" text="{{ 'Katalog Container zuordnen' | translate }}" icon="fields" name="containern"
                                [onClick]="showCopyToContainerDialog"></dxi-button>
                </dxi-column>

            </dx-data-grid>

            <dx-load-panel #loadPanelChecKVirtualCatalogs
                           shadingColor="rgba(0,0,0,0.4)"
                           [position]="{ offset: { x: 0, y: 50 } }"
                           [(visible)]="loading"
                           [showIndicator]="true"
                           [showPane]="true"
                           [shading]="false"
                           [hideOnOutsideClick]="false">
            </dx-load-panel>

            <dx-popover [(target)]="memoTarget"
                        position="bottom"
                        [width]="300"
                        [showTitle]="true"
                        title="Notiz"
                        [(visible)]="memoVisable">
                <div *dxTemplate="let data = model of 'content'">
                    <span [innerHTML]="memoText"></span>
                </div>
            </dx-popover>
        </div>
    </content-column>
    <help-column class="{{ systemService.showHelp ? '' : 'd-none' }}"></help-column>
</fullscreen-page>

<dx-popup class="popup"
          [width]="600"
          [height]="400"
          [showTitle]="true"
          title="{{ 'Neuer Katalog' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="addCatalogVisible"
          contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">
        <newCatalog></newCatalog>
    </div>
</dx-popup>

<dx-popup class="popup"
          [width]="800"
          minHeight="550"
          [height]="'auto'"
          [showTitle]="true"
          title="{{ 'Katalog importieren' | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="importCatalogVisible"
          contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">
        <importCatalog></importCatalog>
    </div>
</dx-popup>

<dx-popup title="{{ 'Datensicherungen' | translate }}"
          [width]="1000"
          [height]="800"
          [dragEnabled]="false"
          [showCloseButton]="true"
          [hideOnOutsideClick]="true"
          [(visible)]="backUpVisible"
          (onHiding)="hideBackUp()"
          contentTemplate="popupContent">
    <dxi-popup-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
        <np-help-button>
            <np-help-option text="YouTube"
                            icon="icon-glyphicons-basic-856-square-play"
                            link="https://www.youtube.com/watch?v=cElY9pFqz2I"></np-help-option>
        </np-help-button>
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'popupContent'">
        <backup></backup>
    </div>
</dx-popup>

<jobdata [(visible)]="jobDataVisible"></jobdata>

<dx-popover [(target)]="target" position="bottom" [width]="300" [showTitle]="false" [(visible)]="imageVisable">
    <div *dxTemplate="let data = model; of: 'content'">
        <img src="{{ source }}{{ mimedate() }}" style="height: 244px" />
    </div>
</dx-popover>

<dx-popup class="popup"
          [width]="600"
          [height]="400"
          [showTitle]="true"
          title="{{ 'Willkommen' | translate }}"
          [dragEnabled]="false"
          [showCloseButton]="true"
          [(visible)]="welcomePopupVisible"
          contentTemplate="popupContent">
    <dxi-popup-toolbar-item toolbar="top" location="after" widget="dxDropDownButton">
        <np-help-button>
            <np-help-option text="Wiki"
                            icon="icon-glyphicons-basic-588-book-open-text"
                            link="https://knowledge.nextpim.de/?utm_source=app.nextpim.de&utm_medium=affiliate&utm_campaign=wikilink"></np-help-option>
            <np-help-option text="YouTube"
                            icon="icon-glyphicons-basic-856-square-play"
                            link="https://www.youtube.com/watch?v=gHtxkwiks9k"></np-help-option>
        </np-help-button>
    </dxi-popup-toolbar-item>
    <div *dxTemplate="let data of 'popupContent'">

        <div *ngIf="!isGastro()" [innerHTML]="'Welcome-Message' | translate"></div>
        <div *ngIf="isGastro()" [innerHTML]="'Welcome-MessageGastro' | translate"></div>
    </div>
</dx-popup>

<dx-popup class="popup"
          [width]="600"
          [height]="450"
          [showTitle]="true"
          title="{{ (containerChooseStep === 'choose' ? 'Container auswählen' : selectedContainerTypeLabel) | translate }}"
          [dragEnabled]="false"
          [hideOnOutsideClick]="true"
          [showCloseButton]="true"
          [(visible)]="containerChooseVisible"
          (onHiding)="hideContainerChoose()"
          contentTemplate="popupContent">
    <div *dxTemplate="let data of 'popupContent'">

        <div *ngIf="containerChooseStep === 'choose'">
            <p>{{ 'Welche Containerart' | translate }}</p>
            <div class="container-choose-options">
                <dx-button *ngFor="let type of containerTypes"
                           class="container-choose-option"
                           stylingMode="outlined"
                           type="default"
                           [text]="type.label | translate"
                           (onClick)="selectContainerType(type.key)"></dx-button>
            </div>
        </div>

        <div *ngIf="containerChooseStep === 'list'">
            <div style="display: flex; align-items: center;">
                <dx-button class="container-choose-back"
                           icon="back"
                           [text]="'Zurück' | translate"
                           (onClick)="backToContainerChoose()"></dx-button>


                <dx-button *ngIf="selectedContainerType =='import'"
                           style="margin-left: auto;"
                           text="Neuer Container"
                           (onClick)="showCreateNewContainerPopUp()">
                </dx-button>
            </div>
            <div *ngIf="selectedContainerType === 'import'" class="dx-field" style="margin: 8px 0;">
                <div class="dx-field-label">{{ 'Verwendung' | translate }}</div>
                <div class="dx-field-value">
                    <dx-radio-group [items]="importUsageItems"
                                    displayExpr="text"
                                    valueExpr="value"
                                    [(value)]="importUsageMode"
                                    layout="vertical">
                    </dx-radio-group>
                </div>
            </div>

            <dx-load-indicator *ngIf="containerObjectsLoading" [height]="30" [width]="30"></dx-load-indicator>

            <dx-list [height]="selectedContainerType === 'import' ? '300px' : '400px'"
                     *ngIf="!containerObjectsLoading"
                     [dataSource]="containerObjects"
                     [displayExpr]="'name'"
                     [searchEnabled]="true"
                     [searchExpr]="'name'"
                     [noDataText]="'Keine Einträge' | translate"
                     selectionMode="single"
                     (onItemClick)="onContainerObjectSelected($event)">
                <div *dxTemplate="let item of 'item'">
                    {{ item?.name || item?.id }}
                </div>
            </dx-list>
        </div>

    </div>
</dx-popup>


<np-container-edit [(visible)]="newContainerDialogVisible"
                   (onSaved)="onContainerSaved($event)"
                   [container]="newImportContainerForCreation"
                   [(containerType)]="containerTypeForEdit"
                   [editMode]="false">
</np-container-edit>
